import React, { useRef, useEffect } from 'react';
import { Layout, Title, Spin } from 'clad';
import GridToolbar from './GridToolbar';

const containerLoadingStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '50vh'
};

const itemLoadingStyle = {
    alignSelf: 'center'
};

export const MaskLoading = props => {
    return (
        <div style={containerLoadingStyle}>
            <div style={itemLoadingStyle}>
                <Spin tip={_('Loading data ...')} />
            </div>
        </div>
    );
};

const { Header, Content } = Layout;

const defaultHeaderStyle = {
    background: 'white',
    padding: '20px 40px 20px 40px',
    height: '100%',
    lineHeight: 1.3,
    position: 'sticky',
    top: 0,
    zIndex: 1
};

const contentStyle = {
    background: 'white'
};

export const GridLayout = props => {
    const {
        title,
        description,
        loading,
        setWidthGrid,
        headerStyle,
        titleStyle
    } = props;

    const containerRef = useRef(null);

    const getContainerWidth = () => {
        return containerRef.current.offsetWidth;
    };

    const setColumnWidth = () => {
        setWidthGrid(getContainerWidth());
    };

    useEffect(
        () => {
            setWidthGrid(getContainerWidth());
            window.addEventListener('resize', setColumnWidth);
            return () => {
                window.removeEventListener('resize', setColumnWidth);
            };
        },
        [containerRef]
    );

    return (
        <React.Fragment>
            <Layout style={{ minWidth: '550px' }}>
                <Header style={{ ...defaultHeaderStyle, ...headerStyle }}>
                    <Title style={titleStyle} ref={containerRef}>
                        {title}
                        <div>{description}</div>
                    </Title>
                    <GridToolbar loading={loading} />
                </Header>
                <Content style={contentStyle}>{props.children}</Content>
            </Layout>
        </React.Fragment>
    );
};
